import * as React from "react";
import { useState, useMemo } from "react";
import usePermissions from "hooks/usePermissions";
import BootstrapModalConfirm from "components/bootstrap/BootstrapModalConfirm";
import { Icon } from "components/common";
import Routes from "routing/Routes";
import { useRemoveEvidence } from "security-app/hooks/useInvestigationsAPI";
import useHistory from "routing/useHistory";
import { EvidenceList, EvidenceRow, IconButton, StyledLink } from "../styled.components";
function Dashboards({ investigation }) {
  const { isPermitted } = usePermissions();
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteDashboardId, setDeleteDashboardId] = useState(null);
  const history = useHistory();
  const canManageEvidence = useMemo(
    () => !investigation.archived && isPermitted("investigations:edit"),
    [investigation.archived, isPermitted]
  );
  const { removeEvidence, removingEvidence } = useRemoveEvidence();
  const removeDashboard = async () => {
    await removeEvidence({ invId: investigation.id, payload: { dashboards: [deleteDashboardId] } });
    setShowDeleteDialog(false);
    setDeleteDashboardId(null);
  };
  const onDelete = (dashboardId) => (e) => {
    e.stopPropagation();
    setShowDeleteDialog(true);
    setDeleteDashboardId(dashboardId);
  };
  const onCancelDelete = () => {
    setShowDeleteDialog(false);
    setDeleteDashboardId(null);
  };
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(EvidenceList, null, investigation.dashboards.length === 0 ? /* @__PURE__ */ React.createElement("div", { style: { color: "gray" } }, "There are no dashboards to list") : investigation.dashboards.map((dashboard) => /* @__PURE__ */ React.createElement(EvidenceRow, { key: dashboard.id, $fullWidth: true, $gap: "0" }, canManageEvidence && /* @__PURE__ */ React.createElement(IconButton, { $danger: true, "data-testid": `delete-${dashboard.id}`, onClick: onDelete(dashboard.id) }, /* @__PURE__ */ React.createElement(Icon, { name: "close" })), /* @__PURE__ */ React.createElement(StyledLink, { onClick: () => history.push(Routes.VIEWS.VIEWID(dashboard.id)) }, dashboard.title)))), /* @__PURE__ */ React.createElement(
    BootstrapModalConfirm,
    {
      showModal: showDeleteDialog,
      title: "Delete Dashboard",
      onConfirm: removeDashboard,
      onCancel: onCancelDelete,
      confirmButtonDisabled: removingEvidence
    },
    "Are you sure you want to delete this Dashboard?"
  ));
}
export default Dashboards;
